import LandingLayout from "../../Shared/layouts/landingLayout";
import HeaderLeadMainSectionUnic from '../landingUnic/HeaderLedMainSectionUnic';
import FeaturesSection from '../landingUnic/FeaturesSection';
import RentalDifferencesSection from "./RentalDifferencesSection";
import VentanillaUnicaSection from "./VentanillaUnicaSection";
import WinahostHelpSection from "./WinahostHelpSection";
import ContactFormUnic from "./ContactFormUnic";
import FaqUnic from "./FaqUnic";

const LandingUnic = () => (
  <LandingLayout>
    <HeaderLeadMainSectionUnic />
    <VentanillaUnicaSection />
    <WinahostHelpSection />
    <RentalDifferencesSection />
    <FeaturesSection />
    <ContactFormUnic />
    <FaqUnic />
  </LandingLayout>
);

export default LandingUnic;
